// extracted by mini-css-extract-plugin
export default {"card-container":"Card_card-container__+GMvH","card-title":"Card_card-title__jXNFa","card-title-text":"Card_card-title-text__5X7A8","card":"Card_card__v45M+"};